export class UpdateCantidadTipoGarantiaRequest{
  public id!:number
  public idTipoGarantia!:number
  public cantidad!:number
  }
